import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3082f101"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3082f101')) {
      api.createRecord('3082f101', component.options)
    } else {
      api.reload('3082f101', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3082f101", function () {
      api.rerender('3082f101', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/designCategory/components/Title/index.vue"
export default component.exports